const Envelope = () => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <path
        d="M59.429 9H4.57a4.557 4.557 0 0 0-3.232 1.347A4.615 4.615 0 0 0 0 13.6v36.8c0 1.22.482 2.39 1.339 3.253A4.557 4.557 0 0 0 4.57 55H59.43a4.557 4.557 0 0 0 3.232-1.347A4.615 4.615 0 0 0 64 50.4V13.6c0-1.22-.482-2.39-1.339-3.253A4.557 4.557 0 0 0 59.43 9ZM54.4 13.6 32 29.194 9.6 13.6h44.8ZM4.571 50.4V15.693l26.126 18.193a2.276 2.276 0 0 0 2.606 0l26.126-18.193V50.4H4.57Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Envelope;
